import { CATEGORY_ORDER } from "../deviceCategories";
import type { CountCategories, DefaultCategory } from "./types";

export const countCategories: CountCategories = (devices) =>
  CATEGORY_ORDER.flatMap((category) => {
    const ofCategory = devices.filter((device) => device.category === category);
    if (!ofCategory.length) return [];
    return [
      {
        category,
        total: ofCategory.length,
        open: ofCategory.filter((device) => device.kind !== "onCircuit").length,
      },
    ];
  });

// The category with the most devices still waiting for a circuit, so the mode opens on the work.
export const defaultCategory: DefaultCategory = (counts) => {
  if (!counts.length) return null;
  const waiting = [...counts].sort((a, b) => b.open - a.open)[0];
  return waiting.open > 0 ? waiting.category : counts[0].category;
};
